import { SnackErrorProps } from '../../interfaces/snack.interface'
import c from 'classnames'
import styles from './SnackError.module.scss'

const SnackErrorComponent = ({ children, onError }: SnackErrorProps) => {
    return (
        <div className={c(
            styles.snackbar,
            onError && styles.showError
        )}>
            {children}
        </div>
    )
}

export default SnackErrorComponent
